<template lang="pug">
.container-fluid.animated.fadeIn
  nav(aria-label="breadcrumb")
    b-breadcrumb
      b-breadcrumb-item
        router-link(to="/account")
          i.fa.fa-users
          span.ml-1 {{ $t("title.accounts") }}
      b-breadcrumb-item
        router-link(to="/account/accountList")
          i.fa.fa-list-alt
          span.ml-1 {{ $t("title.account_list") }}
          //- span | {{ target_id }} | {{ parentId }}

  .row
    .col-md-12
      .form-row
        .col-xs-10.col-sm-6.col-md-4.col-lg-4.mb-1
          b-input-group(size="sm")
            b-input-group-text(slot="prepend")
              i.icon-user
            DebounceInput(
              type="search"
              v-model.trim.lazy="search_id"
              :placeholder="$t('ui.account_id')"
              :disabled="loading"
            )
        .col-xs-10.col-sm-6.col-md-2.col-lg-2.mb-1
          b-input-group(size="sm")
            b-input-group-text(slot="prepend")
              i.icon-question
            b-form-select(v-model="account_status")
              option(value="") {{ $t('ui.all') }}
              option(value="ACTIVE") {{ $t('ui.active') }}
              option(value="SUSPEND") {{ $t('ui.suspended') }}
              option(value="FREEZE") {{ $t("ui.freezed") }}
        //- .col-xs-10.col-sm-6.col-md-4.col-lg-3.mb-1
        //-   DateRangePicker(:title="$t('ui.date_range')" :value="dateRange")

        .col-xs-2.col-sm-2.col-md-2.col-lg-6.mb-1
          SubmitButton(
            :loading="loading"
            icon="fa fa-search"
            :text="$t('ui.search')"
            type="button"
            @click="submit"
            variant="success"
            size="sm"
          )
        //- PLATFORM FEE
        //-
        //-   b-button.btn-brand.float-right(
        //-     type="button"
        //-     variant="info"
        //-     size="sm"
        //-     :disabled="loading"
        //-     @click="editPlatform"
        //-     ).mr-1
        //-     i.fas.fa-cog
        //-     span {{ $t("ui.platform") }}

  b-row
    b-col
      b-breadcrumb.py-1.px-2.mb-1.text-xs.rounded-1
        b-breadcrumb-item(@click="drillIn()")
          span {{ $t("ui.company") }}
        b-breadcrumb-item(
          v-for="(item, index) in lines"
          :key="index"
          :text="item.account_id"
          :class="{ active: index==lines.length - 1 }"
          @click="drillIn(item.account_id)"
        )

  //- AGENT
  .row
    .col-md-12
      .card.mb-1
        .card-header.p-2.bg-gradient-light
          i.fa.fa-user-secret
          span {{ $t("title.agent") }}
        .card-body.p-1
          b-row
            .col-md-10
              b-pagination.float-left(
                size="sm"
                hide-ellipsis
                :total-rows="totalRows"
                :per-page="perPage"
                v-model="currentPage"
                @input="changedPage($event)").mb-1
            .col-md-2
              b-input-group(:prepend="$t('ui.page_size')" size="sm").mb-1
                b-form-select(:options="$store.getters.pageSizeOptions" :value="perPage" @input="changedPageSize")
          b-row
            .col-sm-12.col-md-12.col-lg-12.col-xl-12
              .table-responsive.m-0
                b-table#accountList.table-sm.table-hover.m-0(
                  show-empty
                  :empty-text="$t('message.no_records')"
                  :no-local-sorting="true"
                  responsive
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :items="accountList"
                  :fields="fields"
                  :per-page="perPage"
                  @sort-changed="sortingChanged"
                  )
                  template(v-slot:cell(index)="row")
                    .text-center {{ row.index + 1 }}
                  template(v-slot:cell(account_id)="row")
                    .text-left
                      span.cursor-pointer(@click="drillIn(row.item.account_id)") #[b {{ row.item.account_id }}]
                  template(v-slot:cell(status)="row")
                    .text-left
                      select(v-model="row.item.status" @change="updateStatus(row.item, $event)")
                        option(value="ACTIVE") {{ $t("ui.active") }}
                        option(value="SUSPEND") {{ $t("ui.suspended") }}
                        option(value="FREEZE") {{ $t("ui.freezed") }}
                  template(v-slot:cell(currency_code)="row")
                    .text-center
                      currency(:currency="row.item.currency_code")
                  template(v-slot:cell(account_balance)="row")
                    .text-right
                      span(
                        :class="$helpers.getNumberClass(row.item.account_balance)"
                        )
                        | #[b {{ row.item.account_balance | currency }}]
                      template(v-if="row.item.outstanding_balance != null && row.item.outstanding_balance != 0")
                        br
                        span(
                          :class="$helpers.getNumberClass(row.item.outstanding_balance)"
                          )
                          | (#[b {{ row.item.outstanding_balance | currency }}])
                  template(v-slot:cell(portion)="row")
                    .text-right
                      span(
                        :class="$helpers.getNumberClass(row.item.portion)"
                        )
                        | #[b {{ row.item.portion }}]
                  template(v-slot:cell(action)="row")
                    .d-flex.align-items-center.justify-content-start
                      //- action
                      b-link.action-item.fa.fa-unlock.text-danger.action-danger(
                        v-if="row.item.profile_status.toUpperCase() == 'BLOCK'"
                        href="javascript:;"
                        :title="$t('ui.unblock')"
                        @click="unblock(row.item)"
                        :disabled="!isRoot"
                        )
                      b-link.action-item.fa.fa-lock.text-primary(
                        v-else
                        href="javascript:;"
                        :title="$t('ui.block')"
                        @click="block(row.item)"
                        :disabled="!isRoot"
                        )
                      b-link.action-item.fa.fa-key.text-primary(
                        href="javascript:;"
                        :title="$t('ui.password')"
                        @click="resetPassword(row.item)"
                        :disabled="!isRoot"
                        )
                      b-link.action-item.fa.fa-address-card.text-primary(
                        href="javascript:;"
                        :title="$t('ui.profile')"
                        @click="editProfile(row.item)"
                        :disabled="!isRoot"
                        )
                      b-link.action-item.fa.fa-gamepad.text-primary(
                        href="javascript:;"
                        :title="$t('ui.game_provider')"
                        @click="editProvider(row.item)"
                        :disabled="!isRoot"
                        )
                      b-link.action-item.fa.fa-filter.text-primary(
                        href="javascript:;"
                        :title="$t('ui.bet_limit')"
                        @click="editBetLimit(row.item)"
                        :disabled="!isRoot"
                        )
                      //- reports
                      b-link.action-item.fa.fa-table.text-primary.action-secondary(
                        href="javascript:;"
                        :title="$t('title.daily_winlose')"
                        @click="showReport(row.item, '/report/dailyWinLose')"
                        )
                      b-link.action-item.fa.fa-list-alt.text-primary.action-secondary(
                        href="javascript:;"
                        :title="$t('title.daily_statement')"
                        @click="showReport(row.item, '/report/dailyStatement')"
                        )
                      b-link.action-item.fa.fa-th-list.text-primary.action-secondary(
                        href="javascript:;"
                        :title="$t('title.daily_earning_1')"
                        @click="showReport(row.item, '/report/dailyEarning')"
                        )
                      b-link.action-item.fa.fa-list-ol.text-primary.action-secondary(
                        href="javascript:;"
                        :title="$t('title.daily_earning_2')"
                        @click="showReport(row.item, '/report/dailyEarningByDate')"
                        )
                  template(v-slot:cell(log)="row")
                    .text-left
                      select(v-model="selectedLog" @change="showLog(row.item, $event)")
                        option(value="") &nbsp;
                        option(value="transferLog") {{ $t("title.transfer_log") }}
                        option(value="accountLog") {{ $t("title.account_log") }}
                        option(value="agentLoginLog") {{ $t("title.agent_login") }}
                        option(value="memberLoginLog") {{ $t("title.member_login") }}
                        option(value="profileLog") {{ $t("title.profile_log") }}
                        option(value="authorityLog") {{ $t("title.authority_log") }}
                        option(value="betLimitLog") {{ $t("title.betlimit_log") }}
                        option(value="betLimitSportsLog") {{ $t("title.betlimit_sports_log") }}
                  template(v-slot:cell(full_name)="row")
                    .d-flex.align-items-center.justify-content-start.flex-column
                      b-button.btn-collapse(size="sm" block v-b-toggle="'collapse-' + row.item.account_id" variant="link")
                        .d-flex.align-items-center.justify-content-start
                          i.fa.fa-chevron-down(aria-hidden="true")
                          .text-left {{ row.item.full_name }}
                          .badge.badge-danger(v-if="row.item.login_attempt" :title="$t('ui.login_attempt')") {{ row.item.login_attempt }}
                      b-collapse(
                        :id="'collapse-' + row.item.account_id"
                        accordion="accordion-account"
                        )
                        .table-responsive
                          table.table.table-sm.table-b-0
                            tbody
                              tr
                                td(style="width: 24px;")
                                  i.fa.fa-phone.text-zero
                                td
                                  span {{ row.item.contact_phone }}
                              tr
                                td
                                  i.fa.fa-envelope.text-zero
                                td
                                  span {{ row.item.contact_email }}
                              tr
                                td
                                  i.fa.fa-clock.text-zero
                                td
                                  span(v-if="row.item.last_login_time") {{ $moment(row.item.last_login_time).format("YYYY-M-DD HH:mm:ss") }}
                              tr
                                td
                                  i.fa.fa-location-arrow.text-zero
                                td
                                  template(v-if="row.item.last_login_ip")
                                    a(href="javascript:;" @click="openGeoLocation(row.item.last_login_ip)")
                                      span {{ row.item.last_login_ip }}

  //- MEMBER
  .row
    .col-md-12
      .card.mb-1
        .card-header.p-2.bg-gradient-light
          i.fa.fa-user
          span {{ $t("title.member") }}
        .card-body.p-1
          b-row
            .col-md-10
              b-pagination.float-left(
                size="sm"
                hide-ellipsis
                :total-rows="member.totalRows"
                :per-page="perPage"
                v-model="member.currentPage"
                @input="memberChangedPage($event)").mb-1
            .col-md-2
              b-input-group(:prepend="$t('ui.page_size')" size="sm").mb-1
                b-form-select(:options="$store.getters.pageSizeOptions" :value="perPage" @input="changedPageSize")
          b-row
            .col-sm-12.col-md-12.col-lg-12.col-xl-12
              .table-responsive.m-0
                b-table#memberList.table-sm.table-hover.m-0(
                  show-empty
                  :empty-text="$t('message.no_records')"
                  :no-local-sorting="true"
                  responsive
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :items="member.list"
                  :fields="memberFields"
                  :per-page="perPage"
                  @sort-changed="sortingChanged"
                  )
                  template(v-slot:cell(index)="row")
                    .text-center {{ row.index + 1 }}
                  template(v-slot:cell(account_id)="row")
                    .text-left
                      span #[ {{ row.item.account_id }}]
                  template(v-slot:cell(status)="row")
                    .text-left
                      select(v-model="row.item.status" @change="updateMemberStatus(row.item, $event)")
                        option(value="ACTIVE") {{ $t("ui.active") }}
                        option(value="SUSPEND") {{ $t("ui.suspended") }}
                        option(value="FREEZE") {{ $t("ui.freezed") }}
                  template(v-slot:cell(currency_code)="row")
                    .text-center
                      currency(:currency="row.item.currency_code")
                  template(v-slot:cell(account_balance)="row")
                    .text-right
                      span(
                        :class="$helpers.getNumberClass(row.item.account_balance)"
                        )
                        | #[b {{ row.item.account_balance | currency }}]
                      template(v-if="row.item.outstanding_balance != null && row.item.outstanding_balance != 0")
                        br
                        span(
                          :class="$helpers.getNumberClass(row.item.outstanding_balance)"
                          )
                          | (#[b {{ row.item.outstanding_balance | currency }}])
                  template(v-slot:cell(action)="row")
                    .d-flex.align-items-center.justify-content-start
                      //- action
                      b-link.action-item.fa.fa-unlock.text-danger.action-danger(
                        v-if="row.item.profile_status.toUpperCase() == 'BLOCK'"
                        href="javascript:;"
                        :title="$t('ui.unblock')"
                        @click="unblockMember(row.item)"
                        )
                      b-link.action-item.fa.fa-lock.text-primary(
                        v-else
                        href="javascript:;"
                        :title="$t('ui.block')"
                        @click="blockMember(row.item)"
                        )
                      b-link.action-item.fa.fa-key.text-primary(
                        href="javascript:;"
                        :title="$t('ui.password')"
                        @click="resetMemberPassword(row.item)"
                        )
                      b-link.action-item.fa.fa-address-card.text-primary(
                        href="javascript:;"
                        :title="$t('ui.profile')"
                        @click="editMemberProfile(row.item)"
                        )
                      b-link.action-item.fa.fa-gamepad.text-primary(
                        href="javascript:;"
                        :title="$t('ui.game_provider')"
                        @click="editMemberProvider(row.item)"
                        )
                      b-link.action-item.fa.fa-filter.text-primary(
                        href="javascript:;"
                        :title="$t('ui.bet_limit')"
                        @click="editMemberBetLimit(row.item)"
                        )

                      //- reports
                      b-link.action-item.fa.fa-table.text-primary.action-secondary(
                        href="javascript:;"
                        :title="$t('title.daily_winlose')"
                        @click="showReport(row.item, '/report/dailyWinLose')"
                        )
                      b-link.action-item.fa.fa-list-alt.text-primary.action-secondary(
                        href="javascript:;"
                        :title="$t('title.daily_statement')"
                        @click="showReport(row.item, '/report/dailyStatement')"
                        )
                      b-link.action-item.fa.fa-th-list.text-primary.action-secondary(
                        href="javascript:;"
                        :title="$t('title.daily_earning_1')"
                        @click="showReport(row.item, '/report/dailyEarning')"
                        )
                      b-link.action-item.fa.fa-list-ol.text-primary.action-secondary(
                        href="javascript:;"
                        :title="$t('title.daily_earning_2')"
                        @click="showReport(row.item, '/report/dailyEarningByDate')"
                        )

                    .d-flex.align-items-center.justify-content-start
                      //- member
                      b-link.action-item.fa.fa-history.text-secondary.action-info(
                        href="javascript:;"
                        :title="$t('title.transfer_history')"
                        @click="showReport(row.item, '/report/transferHistory')"
                        )
                      b-link.action-item.fa.fa-plus.text-secondary.action-info(
                        href="javascript:;"
                        :title="$t('title.adjustment_deposit')"
                        @click="doAdjustmentMember(row.item, 'DEPOSIT')"
                        )
                      b-link.action-item.fa.fa-minus.text-secondary.action-info(
                        href="javascript:;"
                        :title="$t('title.adjustment_withdrawal')"
                        @click="doAdjustmentMember(row.item, 'WITHDRAWAL')"
                        )
                      b-link.action-item.fa.fa-download.text-secondary.action-info(
                        href="javascript:;"
                        :title="$t('title.manual_deposit')"
                        @click="doManualDeposit(row.item)"
                        )
                      b-link.action-item.fa.fa-upload.text-secondary.action-info(
                        href="javascript:;"
                        :title="$t('title.manual_withdrawal')"
                        @click="doManualWithdrawal(row.item)"
                        )

                      //- Bank TAC
                      //- b-link.action-item.fa.fa-phone-square.text-secondary.action-tac(
                      //-   href="javascript:;"
                      //-   :title="$t('title.bank_tac')"
                      //-   @click="viewBankTac(row.item)"
                      //-   )
                  template(v-slot:cell(log)="row")
                    .text-left
                      select(v-model="selectedLog" @change="showLog(row.item, $event)")
                        option(value="") &nbsp;
                        option(value="transferLog") {{ $t("title.transfer_log") }}
                        option(value="accountLog") {{ $t("title.account_log") }}
                        option(value="agentLoginLog") {{ $t("title.agent_login") }}
                        option(value="memberLoginLog") {{ $t("title.member_login") }}
                        option(value="profileLog") {{ $t("title.profile_log") }}
                        option(value="authorityLog") {{ $t("title.authority_log") }}
                        option(value="betLimitLog") {{ $t("title.betlimit_log") }}
                        option(value="betLimitSportsLog") {{ $t("title.betlimit_sports_log") }}
                  template(v-slot:cell(full_name)="row")
                    .d-flex.align-items-center.justify-content-start.flex-column
                      b-button.btn-collapse(size="sm" block v-b-toggle="'collapse-' + row.item.account_id" variant="link")
                        .d-flex.align-items-center.justify-content-start
                          i.fa.fa-chevron-down(aria-hidden="true")
                          .text-left {{ row.item.full_name }}
                          .badge.badge-danger(v-if="row.item.login_attempt" :title="$t('ui.login_attempt')") {{ row.item.login_attempt }}
                      b-collapse(
                        :id="'collapse-' + row.item.account_id"
                        accordion="accordion-account"
                        )
                        .table-responsive
                          table.table.table-sm.table-b-0
                            tbody
                              tr
                                td(style="width: 24px;")
                                  i.fa.fa-phone.text-zero
                                td
                                  span {{ row.item.contact_phone }}
                              tr
                                td
                                  i.fa.fa-envelope.text-zero
                                td
                                  span {{ row.item.contact_email }}
                              tr
                                td
                                  i.fa.fa-clock.text-zero
                                td
                                  span(v-if="row.item.last_login_time") {{ $moment(row.item.last_login_time).format("YYYY-M-DD HH:mm:ss") }}
                              tr
                                td
                                  i.fa.fa-location-arrow.text-zero
                                td
                                  span {{ row.item.last_login_ip }}


  editProfile(ref="editProfile" @done="submit")
  resetPassword(ref="resetPassword" @done="submit")
  editProvider(ref="editProvider")
  editBetLimit(ref="editBetLimit" @done="submit")
  adjustMember(ref="adjustMember" @done="submit")
  manualWithdrawal(ref="manualWithdrawal" @done="submit")
  manualDeposit(ref="manualDeposit" @done="submit")
  editPlatform(ref="editPlatform" @done="submit")
  //- bankTac(ref="bankTac")

  #end-report.mt-3
</template>

<script>
import { minLength } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";

import DateRangePicker from "@/library/DateRangePicker.vue";
import DebounceInput from "@/library/DebounceInput";
import ValidateResult from "@/library/ValidateResult";
import SubmitButton from "@/library/SubmitButton.vue";
import currency from "@/components/currency.vue";

import editProfile from "@/components/account/editProfile.vue";
import resetPassword from "@/components/account/resetPassword.vue";
import editProvider from "@/components/account/editProvider.vue";
import editBetLimit from "@/components/account/editBetLimit.vue";
import adjustMember from "@/components/account/adjustMember.vue";
import manualWithdrawal from "@/components/account/manualWithdrawal.vue";
import manualDeposit from "@/components/account/manualDeposit.vue";
import editPlatform from "@/components/account/editPlatform.vue";
// import bankTac from "@/components/account/bankTac.vue";

import xhr from "@/plugins/xhr.js";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    ValidateResult,
    DateRangePicker,
    currency,
    editProfile,
    resetPassword,
    editProvider,
    editBetLimit,
    adjustMember,
    manualWithdrawal,
    manualDeposit,
    // bankTac
    editPlatform
  },
  data() {
    return {
      selectedLog: "",
      loading: false,
      accountList: [],
      member: {
        list: [],
        total: {},
        currentPage: 1,
        totalRows: 0
      },
      account_id: "",
      account_status: "",
      search_id: "",
      target_id: "",
      lines: [],
      sortBy: "account_id",
      sortDesc: false,
      currentPage: 1,
      totalRows: 0
    };
  },
  validations: {},
  computed: {
    isRoot() {
      // return this.target_id == null || this.target_id == "";
      return this.lines.length <= 0;
    },
    parentId() {
      if (this.target_id) return this.target_id;
      if (this.lines.length <= 0) return null;
      return this.lines[this.lines.length - 1].account_id;
    },
    fields() {
      return [
        {
          key: "account_id",
          label: this.$t("ui.account_id"),
          sortable: false,
          thStyle: {
            width: "160px"
          }
        },
        {
          key: "status",
          label: this.$t("ui.status"),
          class: "text-left",
          thStyle: {
            width: "90px"
          }
        },
        // {
        //   key: "currency_code",
        //   label: this.$t("ui.currency"),
        //   class: "text-center",
        //   thStyle: {
        //     width: "75px"
        //   }
        // },
        {
          key: "account_balance",
          label: this.$t("ui.balance"),
          class: "text-right",
          thStyle: {
            width: "160px"
          }
        },
        {
          key: "portion",
          label: this.$t("ui.portion"),
          class: "text-right",
          thStyle: {
            width: "75px"
          }
        },
        {
          key: "action",
          label: this.$t("ui.action"),
          thStyle: {
            width: "240px"
          }
        },
        {
          key: "log",
          label: this.$t("ui.log"),
          thStyle: {
            width: "90px"
          }
        },
        {
          key: "full_name",
          label: this.$t("ui.profile"),
          class: "text-left"
        },
        {
          key: "refer_account_id",
          label: this.$t("ui.referer"),
          class: "text-left",
          thStyle: {
            width: "80px"
          }
        }
      ];
    },
    memberFields() {
      return [
        {
          key: "account_id",
          label: this.$t("ui.account_id"),
          sortable: false,
          thStyle: {
            width: "160px"
          }
        },
        {
          key: "status",
          label: this.$t("ui.status"),
          class: "text-left",
          thStyle: {
            width: "90px"
          }
        },
        // {
        //   key: "currency_code",
        //   label: this.$t("ui.currency"),
        //   class: "text-center",
        //   thStyle: {
        //     width: "75px"
        //   }
        // },
        {
          key: "account_balance",
          label: this.$t("ui.balance"),
          class: "text-right",
          thStyle: {
            width: "235px"
          }
        },
        {
          key: "action",
          label: this.$t("ui.action"),
          thStyle: {
            width: "240px"
          }
        },
        {
          key: "log",
          label: this.$t("ui.log"),
          thStyle: {
            width: "90px"
          }
        },
        {
          key: "full_name",
          label: this.$t("ui.profile"),
          class: "text-left"
        },
        {
          key: "refer_account_id",
          label: this.$t("ui.referer"),
          class: "text-left",
          thStyle: {
            width: "80px"
          }
        }
      ];
    },
    perPage() {
      return this.$store.getters.pageSize;
    },
    direction() {
      return this.sortDesc ? "DESC" : "ASC";
    },
    dateRange() {
      return [this.$moment(this.$store.getters.dateRange[0]), this.$moment(this.$store.getters.dateRange[1])];
    }
  },
  mounted() {
    var q = this.$route.query;
    if (q["id"] != null) {
      this.search_id = q["id"];
    }
    this.submit();
  },
  methods: {
    showLog(e, f) {
      this.$router.push("/log/" + this.selectedLog + "?id=" + e.account_id);
    },
    showReport(e, f) {
      this.$router.push(f + "?id=" + e.account_id);
    },
    openGeoLocation(e) {
      window.open("https://ipgeolocation.io/ip-location/" + e, "ipgeolocation", `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,width=600,height=300`);
    },
    memberChangedPage(e) {
      this.member.currentPage = e;
      this.getMemberList();
    },
    changedPage(e) {
      this.currentPage = e;
      this.getList();
    },
    changedPageSize(e) {
      this.$store.dispatch("layout/setPageSize", e);
      this.currentPage = 1;
      this.member.currentPage = 1;
      this.submit();
    },
    sortingChanged(e) {
      if (e.sortBy !== this.sortBy) {
        this.sortDesc = false;
      } else {
        this.sortDesc = this.direction === "ASC";
      }

      this.sortBy = e.sortBy;
      this.submit();
    },
    submit() {
      this.getList();
      this.getMemberList();
    },
    getList() {
      if (!this.$v.$invalid) {
        var args = {
          session_token: this.$store.getters.sessionToken,
          action_by: this.$store.getters.username
        };
        args["target_account_id"] = this.target_id || null;
        args["search_id"] = this.search_id || null;
        args["account_status"] = this.account_status || null;
        args["page_number"] = parseInt(this.currentPage);
        this.currentPage = args["page_number"];
        args["page_size"] = this.perPage;
        args["sort_key"] = this.sortBy;
        args["sort_type"] = this.direction;
        this.loading = true;
        xhr
          .doRequest(args, xhr.ACCOUNT.accountList)
          .then(res => {
            this.loading = false;
            this.accountList = res.data.account_list;
            this.lines = res.data.tier;
            this.totalRows = res.data.account_list.length > 0 ? res.data.account_list[0]["totalrows"] : 0;
            this.$root.$emit("bv::table::refresh", "accountList");
          })
          .catch(res => {
            this.loading = false;
            this.$helpers.handleFeedback(res.status);
          });
      }
    },
    getMemberList() {
      if (!this.$v.$invalid) {
        var args = {
          session_token: this.$store.getters.sessionToken,
          action_by: this.$store.getters.username
        };
        args["target_account_id"] = this.target_id || "";
        args["search_id"] = this.search_id || null;
        args["account_status"] = this.account_status || null;
        args["page_number"] = parseInt(this.member.currentPage);
        this.member.currentPage = args["page_number"];
        args["page_size"] = this.perPage;
        args["sort_key"] = this.sortBy;
        args["sort_type"] = this.direction;
        this.loading = true;
        xhr
          .doRequest(args, xhr.ACCOUNT.memberList)
          .then(res => {
            this.loading = false;
            this.member.list = res.data.account_list;
            this.member.totalRows = res.data.account_list.length > 0 ? res.data.account_list[0]["totalrows"] : 0;
            this.$root.$emit("bv::table::refresh", "memberList");
          })
          .catch(res => {
            this.loading = false;
            this.$helpers.handleFeedback(res.status);
          });
      }
    },
    block(e) {
      this.$swal({
        title: this.$t("ui.block"),
        text: this.$t("message.block_account_confirm"),
        type: "info",
        showCancelButton: true,
        allowOutsideClick: false
      }).then(result => {
        if (result["value"] == true) {
          var args = {
            session_token: this.$store.getters.sessionToken,
            action_by: this.$store.getters.username,
            target_account_id: e.account_id
          };
          xhr
            .doRequest(args, xhr.ACCOUNT.blockAccount)
            .then(res => {
              this.loading = false;
              this.submit();
            })
            .catch(res => {
              this.loading = false;
              this.submit();
            });
        }
      });
    },
    unblock(e) {
      this.$swal({
        title: this.$t("ui.unblock"),
        text: this.$t("message.unblock_account_confirm"),
        type: "info",
        showCancelButton: true,
        allowOutsideClick: false
      }).then(result => {
        if (result["value"] == true) {
          var args = {
            session_token: this.$store.getters.sessionToken,
            action_by: this.$store.getters.username,
            target_account_id: e.account_id
          };
          xhr
            .doRequest(args, xhr.ACCOUNT.unblockAccount)
            .then(res => {
              this.loading = false;
              this.submit();
            })
            .catch(res => {
              this.loading = false;
              this.submit();
            });
        }
      });
    },
    updateStatus(e, f) {
      this.$swal({
        title: this.$t("ui.status"),
        text: this.$t("message.update_account_status_confirm"),
        type: "warning",
        showCancelButton: true,
        allowOutsideClick: false
      }).then(result => {
        var args = {
          session_token: this.$store.getters.sessionToken,
          action_by: this.$store.getters.username,
          target_account_id: e.account_id,
          new_status: f.srcElement.value
        };
        xhr
          .doRequest(args, xhr.ACCOUNT.updateStatus)
          .then(res => {
            this.loading = false;
            this.submit();
          })
          .catch(res => {
            this.loading = false;
            this.submit();
          });
      });
    },
    editProfile(e) {
      this.$refs.editProfile.isMember = false;
      this.$refs.editProfile.item = e;
      this.$refs.editProfile.$refs.editProfile.show();
    },
    resetPassword(e) {
      this.$refs.resetPassword.isMember = false;
      this.$refs.resetPassword.item = e;
      this.$refs.resetPassword.$refs.resetPassword.show();
    },
    editProvider(e) {
      this.$refs.editProvider.isMember = false;
      this.$refs.editProvider.item = e;
      this.$refs.editProvider.$refs.editProvider.show();
    },
    editBetLimit(e) {
      this.$refs.editBetLimit.isMember = false;
      this.$refs.editBetLimit.item = e;
      this.$refs.editBetLimit.$refs.editBetLimit.show();
    },
    drillIn(e) {
      this.currentPage = 1;
      this.member.currentPage = 1;
      if (e == null || e == "") {
        this.target_id = "";
        this.search_id = "";
        this.submit();
      } else {
        this.target_id = e;
        this.search_id = "";
        this.submit();
      }
    },
    blockMember(e) {
      this.$swal({
        title: this.$t("ui.block"),
        text: this.$t("message.block_account_confirm"),
        type: "info",
        showCancelButton: true,
        allowOutsideClick: false
      }).then(result => {
        if (result["value"] == true) {
          var args = {
            session_token: this.$store.getters.sessionToken,
            action_by: this.$store.getters.username,
            target_account_id: e.account_id
          };
          xhr
            .doRequest(args, xhr.ACCOUNT.blockMember)
            .then(res => {
              this.loading = false;
              this.submit();
            })
            .catch(res => {
              this.loading = false;
              this.submit();
            });
        }
      });
    },
    unblockMember(e) {
      this.$swal({
        title: this.$t("ui.unblock"),
        text: this.$t("message.unblock_account_confirm"),
        type: "info",
        showCancelButton: true,
        allowOutsideClick: false
      }).then(result => {
        if (result["value"] == true) {
          var args = {
            session_token: this.$store.getters.sessionToken,
            action_by: this.$store.getters.username,
            target_account_id: e.account_id
          };
          xhr
            .doRequest(args, xhr.ACCOUNT.unblockMember)
            .then(res => {
              this.loading = false;
              this.submit();
            })
            .catch(res => {
              this.loading = false;
              this.submit();
            });
        }
      });
    },
    updateMemberStatus(e, f) {
      this.$swal({
        title: this.$t("ui.status"),
        text: this.$t("message.update_account_status_confirm"),
        type: "warning",
        showCancelButton: true,
        allowOutsideClick: false
      }).then(result => {
        if (result["value"] == true) {
          var args = {
            session_token: this.$store.getters.sessionToken,
            action_by: this.$store.getters.username,
            target_account_id: e.account_id,
            new_status: f.srcElement.value
          };
          xhr
            .doRequest(args, xhr.ACCOUNT.updateMemberStatus)
            .then(res => {
              this.loading = false;
              this.submit();
            })
            .catch(res => {
              this.loading = false;
              this.$helpers.showDialog(this.$t("ui.edit_provider"), this.$t("error." + res.status), "error");
              this.submit();
            });
        }
      });
    },
    resetMemberPassword(e) {
      this.$refs.resetPassword.isMember = true;
      this.$refs.resetPassword.item = e;
      this.$refs.resetPassword.$refs.resetPassword.show();
    },
    editMemberProfile(e) {
      this.$refs.editProfile.isMember = true;
      this.$refs.editProfile.item = e;
      this.$refs.editProfile.$refs.editProfile.show();
    },
    editMemberProvider(e) {
      if (this.lines.length > 0) {
        this.$refs.editProvider.parentId = this.lines[this.lines.length - 1].account_id;
        this.$refs.editProvider.isMember = true;
        this.$refs.editProvider.item = e;
        this.$refs.editProvider.$refs.editProvider.show();
      } else {
        this.$refs.editProvider.parentId = null;
        this.$helpers.showDialog(this.$t("ui.edit_provider"), this.$t("error.requestIncompleted"), "error");
      }
    },
    editMemberBetLimit(e) {
      this.$refs.editBetLimit.isMember = true;
      this.$refs.editBetLimit.item = e;
      this.$refs.editBetLimit.$refs.editBetLimit.show();
    },
    doAdjustmentMember(e, f) {
      this.$refs.adjustMember.mode = f;
      this.$refs.adjustMember.item = e;
      this.$refs.adjustMember.$refs.adjustMember.show();
    },
    doManualWithdrawal(e) {
      this.$refs.manualWithdrawal.item = e;
      this.$refs.manualWithdrawal.$refs.manualWithdrawal.show();
    },
    doManualDeposit(e) {
      this.$refs.manualDeposit.item = e;
      this.$refs.manualDeposit.$refs.manualDeposit.show();
    },
    // viewBankTac(e) {
    //   this.$refs.bankTac.accountId = e.account_id;
    //   this.$refs.bankTac.contact_phone = e.contact_phone;
    //   this.$refs.bankTac.$refs.bankTac.show();
    // },
    editPlatform() {
      this.$refs.editPlatform.$refs.editPlatform.show();
    }
  }
};
</script>
